/* The focus chip — "showing the section above <name> · clear". Sits in
 * the card header of every fund tab while a focus is set (Ale ruling
 * 2026-09-02). The name is read from the current record each render. */

import type { RecordTablePayload } from '../RecordTable'
import { chainOf, focusChipLabel, type Focus } from './focus'

export default function FocusChip({
  table,
  focus,
  onClear,
}: {
  table: RecordTablePayload
  focus: Focus
  onClear: () => void
}) {
  const label = focusChipLabel(chainOf(table.segments), focus, table.fund_name)
  return (
    <span className="fa-focuschip" data-testid="focus-chip">
      {label}
      <span className="sep">·</span>
      <button type="button" onClick={onClear} data-testid="focus-clear">
        clear
      </button>
    </span>
  )
}
